import useSWRMutation from 'swr/mutation';
import capsFetcher from '../../shared/capsFetcher';
import useApplication from '../read';

const applicationUpdateFetcher = async (url, { arg: data }) => {
  const res = await capsFetcher({
    method: 'PUT',
    url,
    data,
  });
  return res.data;
};

const useApplicationUpdate = (options) => {
  const { data: application } = useApplication();
  return useSWRMutation(
    `/applications/${application.id}`,
    applicationUpdateFetcher,
    { populateCache: true, revalidate: false, ...options },
  );
};

export default useApplicationUpdate;
